export default "__VITE_ASSET__e451286f__"